/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import type { TabListState } from "./TabList.types";
import type {
  TabListSlots,
  TabListContextValues,
} from "@fluentui/react-components";
import { AppTabListOverflowMenu } from "@1js/acui-tablist";
import { TabListProvider, assertSlots } from "@fluentui/react-components";
import { Tab } from "./Tab";

export const renderTabList = (
  state: TabListState,
  contextValues: TabListContextValues
) => {
  assertSlots<TabListSlots>(state);
  const { tabs, tabListOverflowMenu } = state;

  return (
    <state.root>
      <TabListProvider value={contextValues.tabList}>
        {tabs.map((tabProps) => (
          <Tab key={tabProps.key} {...tabProps} />
        ))}
        <AppTabListOverflowMenu {...tabListOverflowMenu} />
      </TabListProvider>
    </state.root>
  );
};
